import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["backLabel", "description", "disabled", "forwardLabel", "id", "inline", "label", "onGoToNextMonth", "onGoToPreviousMonth", "warning"];
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import IconChevronRight from '@bubble-ui/icon-chevron-right';
import IconChevronLeft from '@bubble-ui/icon-chevron-left';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import TouchableIcon from '@bubble-ui/molecule-touchable-icon';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var DatePickerMonthComponent = function DatePickerMonthComponent(_ref) {
  var backLabel = _ref.backLabel,
    description = _ref.description,
    disabled = _ref.disabled,
    forwardLabel = _ref.forwardLabel,
    id = _ref.id,
    inline = _ref.inline,
    label = _ref.label,
    onGoToNextMonth = _ref.onGoToNextMonth,
    onGoToPreviousMonth = _ref.onGoToPreviousMonth,
    warning = _ref.warning,
    props = _objectWithoutProperties(_ref, _excluded);
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var _getDefaultStyleSheet = getDefaultStyleSheet({
      description: description,
      designContext: designContext,
      disabled: disabled,
      inline: inline,
      warning: warning
    }),
    iconBackWrapperStyle = _getDefaultStyleSheet.iconBackWrapperStyle,
    iconForwardWrapperStyle = _getDefaultStyleSheet.iconForwardWrapperStyle,
    inlineIconBackWrapperStyle = _getDefaultStyleSheet.inlineIconBackWrapperStyle,
    inlineIconForwardWrapperStyle = _getDefaultStyleSheet.inlineIconForwardWrapperStyle,
    inlineModeWrapperStyle = _getDefaultStyleSheet.inlineModeWrapperStyle,
    paragraphSecondaryCorrectFootprintCenteredStyle = _getDefaultStyleSheet.paragraphSecondaryCorrectFootprintCenteredStyle,
    rootStyle = _getDefaultStyleSheet.rootStyle,
    titlePrimarySmallStyle = _getDefaultStyleSheet.titlePrimarySmallStyle,
    titleSecondaryStyle = _getDefaultStyleSheet.titleSecondaryStyle,
    titleSecondaryWrapperStyle = _getDefaultStyleSheet.titleSecondaryWrapperStyle;
  return /*#__PURE__*/React.createElement(View, _extends({}, props, {
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: rootStyle
  }), inline ? /*#__PURE__*/React.createElement(View, {
    style: inlineModeWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: inlineIconBackWrapperStyle
  }, onGoToPreviousMonth ? /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.backIcon,
    ariaLabel: backLabel,
    Icon: IconChevronLeft,
    onPress: onGoToPreviousMonth
  }) : undefined), /*#__PURE__*/React.createElement(View, {
    style: titleSecondaryWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.label,
    numberOfLines: 0,
    style: titlePrimarySmallStyle
  }, label)), /*#__PURE__*/React.createElement(View, {
    style: inlineIconForwardWrapperStyle
  }, onGoToNextMonth ? /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.forwardIcon,
    ariaLabel: forwardLabel,
    Icon: IconChevronRight,
    onPress: onGoToNextMonth
  }) : undefined)) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: titleSecondaryWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.label,
    numberOfLines: 0,
    style: titleSecondaryStyle
  }, label)), onGoToPreviousMonth ? /*#__PURE__*/React.createElement(View, {
    style: iconBackWrapperStyle
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.backIcon,
    ariaLabel: backLabel,
    Icon: IconChevronLeft,
    onPress: onGoToPreviousMonth
  })) : undefined, onGoToNextMonth ? /*#__PURE__*/React.createElement(View, {
    style: iconForwardWrapperStyle
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.forwardIcon,
    ariaLabel: forwardLabel,
    Icon: IconChevronRight,
    onPress: onGoToNextMonth
  })) : undefined), description && /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 0,
    style: paragraphSecondaryCorrectFootprintCenteredStyle,
    tag: "paragraph"
  }, description));
};
DatePickerMonthComponent.displayName = 'DatePickerMonth';
export var DatePickerMonth = withProvisionalOverrideFromContext(DatePickerMonthComponent);
//# sourceMappingURL=index.js.map